import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  callMisApi (URL, header, body, success, error) {
    let payload = {
      endpoint_dyn: URL,
      payload: body
    }
    Vue.axios.post(sessionStorage.Url + 'mis/v1/dyn/v1/request/to/client', payload, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  uploadImage (URL, header, body, success, error) {
    Vue.axios.post(URL + 'upload/v1/upload/image', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  isLogin (URL, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/signin', body).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/add/user', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/list/user', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeUser (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/remove/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRole (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/list/role', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  userDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/get/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  userUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/update/user/code', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  confighDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/branch/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  confighUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/branch/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getHostShift (URL, header, success, error) {
    Vue.axios.get('https://rice-api-dev.extensionsoft.biz/company/v1/host/list', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  branchList (URL, header, success, error) {
    Vue.axios.get(URL + 'mis/v1/branch/list', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  branchConfigUpdate (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/branch/config/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  DashBoard (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/total/profit', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetMisMenuRole (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/mis/get/menu/role', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  UpdateMisMenuRole (URL, header, body, success, error) {
    Vue.axios.post(URL + 'auth/v1/mis/update/role', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  async DashStandardCostProfit (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/sale/total/standardcost/profit', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js